import { modelOptions, post, prop, PropType } from "@typegoose/typegoose";
import { addSchemaKeyHook, getDefaultSchemaOptions, SchemaBase, SchemaConstructorArgs } from "../../schemaBase.js";
import { LoggerSchedule } from "./loggerSchedule.js";

const SCHEMA_KEY = "LoggerParsedUplink" as const;

@modelOptions({ schemaOptions: { ...getDefaultSchemaOptions(SCHEMA_KEY) } })
@post<SchemaBase<LoggerParsedUplink>>(...addSchemaKeyHook(SCHEMA_KEY))
export class LoggerParsedUplink extends SchemaBase<LoggerParsedUplink> {
    static readonly schemaKey = SCHEMA_KEY;
    readonly schemaKey = SCHEMA_KEY;

    @prop({ type: () => Date, required: false })
    public referenceTime?: Date;

    @prop({ type: () => LoggerSchedule, required: false }, PropType.ARRAY)
    public schedules?: LoggerSchedule[];

    @prop({ type: () => Number, required: false })
    public valveCount?: 1 | 2;

    static getters = {} as const satisfies Record<string, (self: LoggerParsedUplink) => any>;

    static utilities = {} as const satisfies Record<string, (...args: any) => any>;

    constructor(properties?: SchemaConstructorArgs<LoggerParsedUplink>) {
        super(properties);
        Object.assign(this, properties);
    }
}
